import { IPropertiesOfPatchChangesForModGroup } from 'types';

export const modGroupProperties: IPropertiesOfPatchChangesForModGroup[] = [
	{ id: 'forceDisable', name: 'forceDisable' },
];
